import {
    UK_LOCATION_RESULT,
    UK_LOCATION_FILTER,
    UK_SPECIALITY_FILTER,
    UK_AUTHOR_LIST,
    UK_TRUST_SELCET
} from "../actions/types";

const initialState = {
    locationResults: [],
    allAuthors: [],
    filter: {
        speciality: {
            value: "",
            label: "Select Speciality...",
            clearableValue: false
        },
        location: {
            value: "Select Location",
            label: "Select Location",
            clearableValue: false,
            coordinates: null
        }
    },
    selectedTrust: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case UK_SPECIALITY_FILTER:
            let filter = {
                ...state.filter,
                speciality: action.payload.speciality
            };
            return {
                ...state,
                filter,
                selectedTrust: null
            };
            break;
        case UK_LOCATION_RESULT:
            return {
                ...state,
                locationResults: action.payload.result
            };
            break;
        case UK_TRUST_SELCET:
            return {
                ...state,
                selectedTrust: action.payload.selectedTrust
            };
            break;

        case UK_AUTHOR_LIST:
            return {
                ...state,
                allAuthors: action.payload.result
            };
            break;
        case UK_LOCATION_FILTER:
            let filter2 = {
                ...state.filter,
                location: action.payload.location
            };
            return {
                ...state,
                filter: filter2
            };
            break;
        default:
            return state;
            break;
    }
};
